/**
 * MacroSummaryStrip — the "סיכום ערכים" strip under a block / sub-block.
 * Four neutral tiles, evenly spaced, each with its macro icon as the only
 * color accent, so the four numbers read as four numbers instead of a
 * crowded run of chips. `tip` explains what is summed (HoverTip on the label).
 */

import HoverTip from "../../ui/HoverTip";
import MacroIcon from "../MacroIcon";
import { MACROS, fmtNum } from "./IngredientRow";
import "./MenuCards.css";

const MacroSummaryStrip = ({ totals, label, tip, variant = "" }) => (
  <div className={`nmb-summary ${variant}`.trim()} role="group" aria-label={label}>
    {label && (
      <HoverTip text={tip} placement="bottom">
        <span className="nmb-summary-label" tabIndex={tip ? 0 : undefined}>
          {label}
        </span>
      </HoverTip>
    )}
    <div className="nmb-summary-grid">
      {MACROS.map((macro) => (
        <div className={`nmb-summary-item nmb-summary-item--${macro.key}`} key={macro.key}>
          <span className="nmb-summary-head">
            <MacroIcon macro={macro.key} size={13} />
            {macro.label}
          </span>
          <span className="nmb-summary-value">
            <strong>{fmtNum(totals?.[macro.key])}</strong>
            <span className="nmb-summary-unit">{macro.unit}</span>
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default MacroSummaryStrip;
